import React from "react";

const BreadcrumbContextApi = React.createContext({});

export default BreadcrumbContextApi;
